(function(){
    "use strict";
    
    angular
        .module("app")
        .component("receive", { // receive
            templateUrl: "src/app/receive/receive.html",
            controller: controller
        });

    function controller(receivesService, productsService, toast) {
        const $ctrl = this;
        $ctrl.pendingReceives = [];
        $ctrl.historicalReceives = [];
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
        $ctrl.search_from_date = sevenDaysAgo;
        $ctrl.search_to_date = new Date();
        $ctrl.unexpected = {
            order_id: null,
            product: null,
            lot: "",
            quantity: null,
            receive_date: new Date(),
            uom: "CT"
        };
        $ctrl.products = [];

        $ctrl.toggles = {};
        $ctrl.toggleDatePicker = datePicker => {
            $ctrl.toggles[datePicker] = !$ctrl.toggles[datePicker];
        };
        const tenYearsAgo = new Date();
        tenYearsAgo.setYear(tenYearsAgo.getFullYear() - 10);

        $ctrl.datePickerOptions = {
            "show-weeks": false,
            timezone: "utc",
            minDate: tenYearsAgo
        };

        $ctrl.$onInit = () => {
            receivesService.searchPending().then(res => {
                $ctrl.pendingReceives = res.map(r => {
                    r.qty = r.order_qty - r.rec_qty;
                    r.rec_date = new Date();
                    return r;
                });
            });
            productsService.getForUnexpectedReceive().then(res => {
                $ctrl.products = res.sort(sortItemDesc);
                $ctrl.unexpected.product = $ctrl.products[0].item_id;
            });
        };

        function sortItemDesc(a, b) {
            if (a.item_desc < b.item_desc)
                return -1;
            if (a.item_desc > b.item_desc)
                return 1;
            return 0;
        }

        $ctrl.canReceive = (rec) => {
            if (!rec.qty)
                return false;

            if (!rec.rec_date)
                return false;

            return true;
        };

        $ctrl.canUnexpectedReceive = (rec) => {
            if (!$ctrl.unexpected.lot)
                return false;

            if (!$ctrl.unexpected.quantity)
                return false;

            if (!$ctrl.unexpected.receive_date)
                return false;

            return true;
        };

        $ctrl.receiveClicked = rec => {
            const req = {
                receive_date: rec.rec_date, 
                order_id: rec.order_id,
                item_id: rec.item_id,
                quantity_received: rec.qty,
                quantity_UOM: rec.order_UOM,
                lot_no: rec.lot_no,
                notes: null
            };
            receivesService
                .create(req)
                .then(res => {
                    toast.success("Receive", "Receive created.");
                    rec.rec_qty = rec.rec_qty + rec.qty;
                    rec.qty = rec.order_qty - rec.rec_qty;
                    if (rec.qty <= 0) {
                        const index = $ctrl.pendingReceives.indexOf(rec);
                        $ctrl.pendingReceives.splice(index, 1);
                    }
                });
        };

        $ctrl.saveUnexpectedClicked = () => {
            const req = {
                receive_date: $ctrl.unexpected.receive_date,
                order_id: $ctrl.unexpected.order_id,
                item_id: $ctrl.unexpected.product,
                quantity_received: $ctrl.unexpected.quantity,
                quantity_UOM: $ctrl.unexpected.uom,
                lot_no: $ctrl.unexpected.lot,
                notes: null
            };
            receivesService
                .create(req)
                .then(res => {
                    toast.success("Receive", "Receive created.");
                    $ctrl.unexpected.order_id = null;
                    $ctrl.unexpected.quantity = null;
                    $ctrl.unexpected.lot = null;
                    $ctrl.unexpected.product = $ctrl.products[0].item_id;
                    $ctrl.unexpected.receive_date = new Date();
                    $ctrl.unexpected.uom = "CT";
                });
        };

        $ctrl.search = () => {
            receivesService
                .searchHistorical($ctrl.search_from_date, $ctrl.search_to_date)
                .then(res => $ctrl.historicalReceives = res);
        };

        $ctrl.cancelClicked = rec => {
            receivesService
                .cancel(rec.order_receive_id)
                .then(res => rec.receive_status_code = "CAN");
        };

        $ctrl.uncancelClicked = rec => {
            receivesService
                .uncancel(rec.order_receive_id)
                .then(res => rec.receive_status_code = "COM");
        };

    }
    controller.$inject = ["receivesService", "productsService", "stToastFactory"];
    
})()